import { useId } from 'react';

import type { ChkIconProps } from './ChkIcon.types';
import { ChkSvgWrapper } from './ChkIcon.utils';

export const ChkIconClose = (iconProps: ChkIconProps) => {
  const clipPathId = useId();

  return (
    <ChkSvgWrapper {...iconProps}>
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M5 19L19 5" stroke="currentColor" strokeWidth="2" />
        <path d="M19 19L5 5" stroke="currentColor" strokeWidth="2" />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </ChkSvgWrapper>
  );
};
